import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { useAppSelector } from "store/hooks"
import {
	bikeFleetForExportSelectedSelector,
	numberOfBikeSelectedSelector,
} from "../slice/bikeFleetSelector"
import { useAlert } from "hooks"
import { SelectStatusBikeFleet } from "./Elements/SelectStatusBikeFleet"
import FleetIcon from "components/Elements/Icons/Fleet"
import { exportData } from "../utils"
import { DEFAULT_SIZE } from "utils/icons"
import { BikeFleetType } from "../types/bikeFleetType"

const HeaderBikeFleet: React.FC = () => {
	const { alert } = useAlert()
	const bikeFleetForExportSelected = useAppSelector(bikeFleetForExportSelectedSelector)
	const numberOfBikesSelected = useAppSelector(numberOfBikeSelectedSelector)
	const noExportPossible = numberOfBikesSelected <= 0
	const { t } = useTranslation()

	const onExport = () => {
		if (noExportPossible)
			return alert("error", t("bikeFleet.noSelectionExportBikeFleet", { ns: "bike" }))
		exportData(bikeFleetForExportSelected as unknown as BikeFleetType[])
	}

	return (
		<div className="c-section-title mb-7 px-8 flex">
			<div
				className={clsx("c-section-title__content justify-between", {
					"items-start": isMobileOnly,
				})}
			>
				<div className="flex items-center justify-start flex-1">
					<FleetIcon size={DEFAULT_SIZE} />
					<h1 className="c-section-title__title c-h2 text-primary ml-4">
						{t("bikeFleet.title", { ns: "bike" })}
					</h1>
				</div>
				<div
					className={clsx("flex gap-4 h-[100%]", {
						"flex-col ": isMobileOnly,
					})}
				>
					<SelectStatusBikeFleet />
					<button
						data-cy="export-bike-fleet"
						disabled={noExportPossible}
						type="button"
						className={clsx("c-btn c-btn--primary px-7 whitespace-nowrap", {
							"flex items-center": isMobileOnly,
						})}
						onClick={onExport}
					>
						{`${t("history.export.exportButton", {
							ns: "partner",
						})} (${numberOfBikesSelected})`}
					</button>
				</div>
			</div>
		</div>
	)
}

export default React.memo(HeaderBikeFleet)
